import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function CheckoutStart() {
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    const checkoutUrl = sessionStorage.getItem("fotg_checkout_url");
    if (!checkoutUrl) {
      setMissing(true);
      return;
    }
    sessionStorage.removeItem("fotg_checkout_url");
    const timer = window.setTimeout(() => {
      window.location.replace(checkoutUrl);
    }, 120);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div className="flex min-h-screen min-w-0 items-center justify-center bg-[#070707] px-4 py-10 text-[#f5f0e7] sm:px-5">
      <Seo
        title="Secure Checkout | Fotos on the Geaux"
        description="Continuing to secure checkout."
        path="/checkout/start"
        robots="noindex,nofollow"
      />
      <div className="text-center">
        {missing ? (
          <>
            <p className="font-accent tracking-[.24em] text-[#c8aa82]">CHECKOUT LINK EXPIRED</p>
            <h1 className="mt-4 font-display text-4xl font-black">Start your checkout again.</h1>
            <Link to="/" className="mt-7 inline-flex rounded-full border border-white/20 px-6 py-3 font-accent text-xs tracking-[.18em]">
              RETURN TO EVENT
            </Link>
          </>
        ) : (
          <>
            <Loader2 className="mx-auto animate-spin text-[#39E75F]" size={42} />
            <p className="mt-6 font-accent tracking-[.24em]">OPENING SECURE CHECKOUT…</p>
          </>
        )}
      </div>
    </div>
  );
}
